import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableCellComponent, dataTableCellTemplate } from './DataTableCell';
import styles from './DataTableCell.styles.scss';
export const dataTableCellDefinition = {
    baseName: 'data-table-cell',
    template: dataTableCellTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonDataTableCell = DataTableCellComponent.compose(dataTableCellDefinition);
